<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="'SOP' + $t('CargoMsg.Cargo_WorkNode') + $t('SeaExport.EditSopStatus')"
    width="420px"
    :close-on-click-modal="false"
  >
    <el-form label-width="60px" label-position="right">
      <el-form-item :label="$t('CargoMsg.Cargo_CurrentNode')">
        <el-select v-model="trackingCode" :disabled="true" no="trackingCode" :placeholder="$t('SeaExport.PleaseSelectANode')" @change="getTrackingDetail">
          <el-option v-for="(item,index) in availableTrackingList" :key="index" :label="item.codeCname" :value="item.code" />
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('Sop.nodeState')">
        <el-select v-model="trackingDetailCode" no="trackingDetailCode" :placeholder="$t('SeaExport.PleaseSelectAState')">
          <el-option v-for="(item,index) in trackingDetailList" :key="index" :label="item.codeCname" :value="item.code" />
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('CargoMsg.Cargo_ProcessingTime')">
        <el-date-picker
          v-model="trackingDetailDate"
          no="trackingDetailDate"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm"
          format="yyyy-MM-dd HH:mm"
          :placeholder="$t('SeaExport.SelectTime')"
          style="width: 340px;"
        />
      </el-form-item>
      <el-form-item :label="$t('CargoMsg.Cargo_ProcessedBy')">
        <el-input :disabled="true" :value="ColumnUtils.resolveColumnLabel(selectTypeNames.basic_data_User, 'userId', Number($store.getters.userId), 'chineseName')" no="trackingUser" />
      </el-form-item>
      <el-form-item :label="$t('CargoMsg.Cargo_Remarks')">
        <el-input v-model="trackingDetailRemark" type="textarea" no="trackingDetailRemark" :rows="3" />
      </el-form-item>
      <el-form-item label=" ">
        <el-checkbox v-model="messageChecked" no="messageChecked">{{ $t('Message.SendStatusChangeNotification') }}</el-checkbox>
      </el-form-item>
      <el-form-item label=" ">
        <span>{{ '*' + $t('Message.OptionIsChecked') }}</span>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button no="confirm" type="primary" @click="confirmEditState">{{ $t('common.btn.confirm') }}</el-button>
      <el-button no="cancel" @click="innerVisible = false">{{ $t('common.btn.cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { updateJobTrackingInfo } from '@/api/seaExport/seaExportJob'
import DateUtils from '@/utils/dateUtils'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'

export default {
  name: 'DashboardStateDialog',
  props: {
    visible: { type: Boolean, required: true },
    rows: { type: Array, default: () => [] },
    filter: { type: Object, default: () => {} }, // 页面上的筛选条件
    trackingList: { type: Array, default: () => [] },
    sopNodeState: { type: String, default: '' }
  },
  data() {
    return {
      ColumnUtils,
      selectTypeNames: TYPE_NAMES,
      innerVisible: false,
      trackingCode: '',
      trackingDetailCode: '',
      trackingDetailDate: '',
      trackingDetailRemark: '',
      messageChecked: true,
      availableTrackingList: [],
      trackingDetailList: []
    }
  },
  computed: {
  },
  watch: {
    visible: {
      immediate: true,
      handler(newVal) {
        this.innerVisible = newVal
        if (newVal) {
          this.trackingDetailDate = new Date()
          this.getTracking()
        }
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
      if (!newVal) {
        this.trackingCode = ''
        this.trackingDetailCode = ''
        this.trackingDetailDate = ''
        this.trackingDetailRemark = ''
        this.messageChecked = true
        this.trackingDetailList = []
      }
    }
  },
  methods: {
    getTracking() {
      this.trackingCode = this.filter.code
      this.trackingDetailCode = ''
      this.availableTrackingList = this.filter.trackingTemplateUuid ? this.trackingList.filter(item => item.trackingTemplateUuid === this.filter.trackingTemplateUuid) : this.trackingList
      this.trackingDetailList = []
      this.getTrackingDetail(this.trackingCode)
      if (this.sopNodeState) {
        this.trackingDetailCode = this.sopNodeState
      }
    },
    getTrackingDetail(trackingCode) {
      this.trackingDetailCode = ''
      this.trackingDetailList = []
      const trackingList = this.availableTrackingList.filter(item => item.code === trackingCode)
      this.trackingDetailList = trackingList[0].trackingDetail
      for (const trackingDetail of this.trackingDetailList) {
        if (trackingDetail.stateType === 3) { // 已完成
          this.trackingDetailCode = trackingDetail.code
          break
        }
      }
    },
    // 确认修改
    async confirmEditState() {
      const loading = getLoading4Cxt(this)
      await this.$confirm(this.$t('CargoMsg.Cargo_EditStateTip', [this.rows.length]), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.confirm'),
        cancelButtonText: this.$t('common.btn.cancel'),
        closeOnClickModal: false,
        showClose: false,
        type: 'warning'
      }).then(() => {
      }).catch(() => {
        loading.close()
        return
      })
      const trackingCode = this.trackingCode
      const trackingDetailCode = this.trackingDetailCode
      if (!trackingCode) {
        loading.close()
        this.$message.warning(this.$t('Message.PleaseSelectABusinessStatus'))
        return
      }
      if (!trackingDetailCode) {
        loading.close()
        this.$message.warning(this.$t('Message.PleaseSelectABusinessStatusDetails'))
        return
      }
      const trackingDetailRemark = this.trackingDetailRemark
      const trackingDetailDate = DateUtils.formatStandardDateTime(this.trackingDetailDate)
      const messageChecked = this.messageChecked
      const jobKeys = Array.from(this.rows, p => p.jobUuid)
      if (jobKeys.length === 0) {
        return
      }
      updateJobTrackingInfo({
        jobKeys, trackingCode, trackingDetailCode, trackingDetailRemark, messageChecked, trackingDetailDate
      }).then(res => {
        loading.close()
        this.updateJobTrackingInfoResult(res.data)
      }).finally(() => {
        loading.close()
      })
    },
    updateJobTrackingInfoResult(result) {
      this.innerVisible = false
      this.$message.success(this.$t('SeaExport.SuccessModifiedXBusinessState', [result]))
      this.$emit('callback')
    }
  }
}
</script>
